// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__L9dSV","hidden":"styles_hidden__GlPVq","shown":"styles_shown__N9Ec9"};